import './App.css';
import './assets/css/style.css';
import { useEffect } from "react";
import { useLocation, Routes, Route } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Home from './pages/Home';
import LogIn from './pages/LogIn';
import PrivateRoute from "./components/PrivateRoute";
import Register from './pages/Register';
import UserSettings from './pages/UserSettings';
import ThemeSelector from './pages/ThemeSelector';
import Stats from './pages/Stats';
import AutoTest from './pages/AutoTest';
import Eval from './pages/Eval';
import FillTheGap from './pages/FillTheGap';
import MixedWords from './pages/MixedWords';
import MixedWordsV1 from './pages/MixedWords-v1';
import WordMatch from './pages/WordMatch';
import WordMatchV1 from './pages/WordMatch-v1';
import ArrowsQCM from './pages/ArrowsQCM';
import VinyleQCM from './pages/VinyleQCM';
import UserManagement from "./pages/UserManagementPage";
import NotFound from "./pages/NotFound";

// Variants d'animation partagés — définis UNE fois hors du composant,
// évite de créer de nouveaux objets à chaque render.
const PAGE_VARIANTS = {
  initial:  { opacity: 0, x: 50 },
  animate:  { opacity: 1, x: 0 },
  exit:     { opacity: 0, x: -50 },
};
const PAGE_TRANSITION = { duration: 0.3 };

const PAGE_VARIANTS_LEFT = {
  initial:  { opacity: 0, x: -50 },
  animate:  { opacity: 1, x: 0 },
  exit:     { opacity: 0, x: 50 },
};

function App() {
  const location = useLocation();

  useEffect(() => {
    document.body.style.overflow = location.pathname === "/" ? "visible" : "hidden";
    return () => { document.body.style.overflow = "visible"; };
  }, [location.pathname]);

  return (
    <div className="App">
      {/*
         FIX : on ne passe PAS `location` en prop à <Routes>.
        Passer l'objet `location` entier causait un re-render de Routes à chaque
        changement de location.state (nouvel objet référence à chaque navigation),
        ce qui déclenchait des cycles exit/enter AnimatePresence → unmount/remount
        des pages-jeu toutes les ~270ms (cadence du setInterval du Timer).
        La prop `key` suffit pour que AnimatePresence joue les animations au
        changement de pathname.
      */}
      <AnimatePresence mode="wait">
        <Routes key={location.pathname}>
          <Route path="/" element={<Home />} />

          <Route path="/login" element={
            <motion.div key="login" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
              <LogIn />
            </motion.div>
          } />

          <Route path="/register" element={
            <motion.div key="register" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
              <Register />
            </motion.div>
          } />

          <Route path="/userSettings" element={
            <PrivateRoute>
              <motion.div key="userSettings" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
                <UserSettings />
              </motion.div>
            </PrivateRoute>
          } />

          <Route
            path="/themeSelector"
            element={
              <PrivateRoute>
                <motion.div key="themeSelector" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
                  <ThemeSelector />
                </motion.div>
              </PrivateRoute>
            }
          />

          <Route path="/stats" element={
            <PrivateRoute>
              <motion.div key="stats" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
                <Stats />
              </motion.div>
            </PrivateRoute>
          } />

          <Route path="/autoTest" element={
            <PrivateRoute>
              <motion.div key="autoTest" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
                <AutoTest />
              </motion.div>
            </PrivateRoute>
          } />

          <Route path="/eval" element={
            <PrivateRoute>
              <motion.div key="eval" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
                <Eval />
              </motion.div>
            </PrivateRoute>
          } />

          <Route path="/fillthegap" element={
            <PrivateRoute>
              <motion.div key="fillthegap" variants={PAGE_VARIANTS_LEFT} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
                <FillTheGap />
              </motion.div>
            </PrivateRoute>
          } />

          <Route path="/settings/users" element={
            <PrivateRoute>
              <UserManagement />
            </PrivateRoute>
          } />

          <Route path="/mixedwords" element={
            <PrivateRoute>
              <motion.div key="mixedwords" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
                <MixedWords />
              </motion.div>
            </PrivateRoute>
          } />

          <Route path="/mixedwordsv1" element={<MixedWordsV1 />} />

          <Route path="/wordmatch" element={
            <PrivateRoute>
              <motion.div key="wordmatch" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
                <WordMatch />
              </motion.div>
            </PrivateRoute>
          } />

          <Route path="/wordmatchV1" element={<WordMatchV1 />} />

          <Route path="/vinyleQCM" element={
            <PrivateRoute>
              <motion.div key="vinyleQCM" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
                <VinyleQCM />
              </motion.div>
            </PrivateRoute>
          } />

          <Route path="/arrowsQCM" element={
            <PrivateRoute>
              <motion.div key="arrowsQCM" variants={PAGE_VARIANTS} initial="initial" animate="animate" exit="exit" transition={PAGE_TRANSITION}>
                <ArrowsQCM />
              </motion.div>
            </PrivateRoute>
          } />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </AnimatePresence>
    </div>
  );
}

export default App;